export enum FOOD_CATEGORIES {
  AppetizersEntreesPotatoesRefFzn = 'APPETIZERS, ENTREES, & POTATOES REF & FZN',
  Beef = 'BEEF',
  Beverage = 'BEVERAGE',
  Cheese = 'CHEESE',
  ChemicalsCleaningAgents = 'CHEMICALS & CLEANING AGENTS',
  Dairy = 'DAIRY',
  Disposables = 'DISPOSABLES',
  EquipmentSupplies = 'EQUIPMENT & SUPPLIES',
  FruitsVegetablesCannedDried = 'FRUITS & VEGETABLES, CANNED & DRIED',
  GroceryDry = 'GROCERY, DRY',
  GroceryRefFzn = 'GROCERY, REF & FZN',
  MeatSubstitute = 'MEAT SUBSTITUTE',
  OilsShortening = 'OILS & SHORTENING',
  Pork = 'PORK',
  Poultry = 'POULTRY',
  ProcessedMeat = 'PROCESSED MEAT',
  ProduceFresh = 'PRODUCE, FRESH',
  SaladsWetRefFzn = 'SALADS, WET, REF & FZN',
  Seafood = 'SEAFOOD',
  SpecialtyMeats = 'SPECIALTY MEATS',
}
